import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 0,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div className="min-h-screen flex items-center justify-center bg-dark-900 text-dark-100 p-6">
          <div className="max-w-md text-center">
            <h1 className="text-xl font-semibold mb-3">Something broke.</h1>
            <p className="text-dark-300 mb-4">
              The error has been reported. You can try again, or refresh the page.
            </p>
            <button
              onClick={resetError}
              className="bg-primary-600 hover:bg-primary-500 text-white rounded px-4 py-2"
            >
              Try again
            </button>
          </div>
        </div>
      )}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
